import { memo } from 'react';

import { Trash2Icon } from '@air/design-icons';

import { MainSideNavItem } from '~/components/v2/components/workspace/main-side-nav/item/MainSideNavItem';
import { MAIN_SIDE_NAV_SMALL_ICON_SIZE } from '~/components/v2/components/workspace/main-side-nav/item/MainSideNavItemButton';
import { useMainSideNavItemSelected } from '~/components/v2/components/workspace/main-side-nav/useMainSideNavItemSelected';
import { Routes } from '~/constants/routes';

export type MainSideNavItemRecentlyDeletedProps = {
  pathname: string;
};

export const MainSideNavItemRecentlyDeleted = memo(({ pathname }: MainSideNavItemRecentlyDeletedProps) => {
  const { isSelected } = useMainSideNavItemSelected({
    isRouteSelected: pathname === Routes.media.recentlyDeleted,
  });

  return (
    <MainSideNavItem
      href={Routes.media.recentlyDeleted}
      icon={Trash2Icon}
      id="recently-deleted"
      isSelected={isSelected}
      iconSize={MAIN_SIDE_NAV_SMALL_ICON_SIZE}
      label="Recently Deleted"
      sidebarInteractionType="recently_deleted"
    />
  );
});

MainSideNavItemRecentlyDeleted.displayName = 'MainSideNavItemRecentlyDeleted';
